import React, { Component } from "react";
import PersonalDetails from "./CandidateDetailsPages/PersonalDetails";
import FamilyDetails from "./CandidateDetailsPages/FamilyDetails";
import EducationDetails from "./CandidateDetailsPages/EducationDetails";
import WorkExperience from "./CandidateDetailsPages/WorkExperience";
import BankDetails from "./CandidateDetailsPages/BankDetails";
import DocumentDetails from "./CandidateDetailsPages/DocumentDetails";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { currentDateAndTime, parseQueryString } from "../../Constants/constants";
import Swal from "sweetalert2";
import ViewOnlyHeader from "../../Layout/ViewOnlyHeader";

class CandidateDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedInfoTab: "1",
      guest_employee_mobile_number: "",
      company_id: "",
      companyInfo: {},
      encryptedData: "",
      isPage404: false,
      loadingList: false,
      msg: "",
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    if (encryptedData) {
      this.setState(
        {
          loadingList:true,
          encryptedData:encryptedData,
          guest_employee_mobile_number: "",
          company_id: "",
          isPage404: false,
        },
        () => {
          this.getDecryptedData();
        }
      );
    } else if (!encryptedData) {
      this.setState({
        encryptedData:'',
        guest_employee_mobile_number: "",
        company_id: "",
        isPage404: "Opps...! Something went wrong!",
      });
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    console.log(this.state.company_id,this.state.guest_employee_mobile_number);
    axios
      .get(`${apiURL}Home/EmployeeCollectedData`, {
        params: {
          // guest_employee_id:"10",
          company_id: this.state.company_id,
          guest_employee_mobile_number: this.state.guest_employee_mobile_number,
          date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        const { employee_data , success, message,data_collection_link_status } = response.data;
        if (success === true) {
          console.log("Personal Details - GetInfo", employee_data);
          this.setState({
            isPage404: false,
            loadingList: false,
          });
        } else {
          if (data_collection_link_status === "4") {
            this.setState({ isPage404: data_collection_link_status, msg: message,loadingList: false, });
          } 
          else if(data_collection_link_status === "3") {
            this.setState({
              isPage404: data_collection_link_status,
              msg: message,
              loadingList: false,
            });
          } else {
            this.setState({
              isPage404: message || "Opps...! Something went wrong!",
              msg:"Opps...! Something went wrong!",
              loadingList: false,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          isPage404:"Opps...! Something went wrong!",
          msg:"Opps...! Something went wrong!",
          loadingList: false,
        });
        Swal.fire({
          title: `<strong>${"Failed"}</strong>`,
          text: "Opps...! Something went wrong!",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        console.error("Error uploading file:", error);
      });
  };
  getDecryptedData = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const fromData={
        encryptedData:this.state.encryptedData
    }
    axios
        .post(`${apiURL}User/DecryptData`,fromData, {headers})
        .then((response) => {
            var data = response.data;
            console.log('DecryptData',data);
            if (response.data.success === true) {
                let temp= parseQueryString(data?.decryptedData);
                console.log("tenp",temp);
                this.setState({
                  company_id:temp?.c_id,
                  guest_employee_mobile_number:temp?.mo_n,
                },()=>{
                  this.GetList();
                });
            } else {
              this.setState({
                isPage404: "Opps...! Something went wrong!",
                msg:"Opps...! Something went wrong!",
                loadingList: false,
              });
            }
        }).catch((error)=>{
          this.setState({
            isPage404:"Opps...! Something went wrong!",
            msg:"Opps...! Something went wrong!",
            loadingList: false,
          });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong !!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        });
};

  handleSubmit = (row, idx) => {
    const formData = {};
    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to submit all details!",
      icon: "warning",
      showCancelButton: true,
      // confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loadingFinalSubmit: true });
        axios
          .post(`${apiURL}Home/FinalDetailSubmission`, formData, {
            params: {
              date: currentDateAndTime(),
              company_id: this.state.company_id,
              guest_employee_mobile_number:
                this.state.guest_employee_mobile_number,
            },
            headers,
          })
          .then((response) => {
            const data = response.data;
            if (response.data.success === true) {
              console.log("FinalDetailSubmission =>",data)
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });

              this.setState({ loadingFinalSubmit: false }, () => {
                this.GetList();
              });
            } else {
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Set your state here
                  if(data?.missing_step){
                    this.setState({ selectedInfoTab: `${data?.missing_step}` });
                  }
                  
                }
              });
              this.setState({ loadingFinalSubmit: false, });
            }
          })
          .catch((error) => {
            this.setState({ loadingFinalSubmit: false });
            Swal.fire({
              title: `<strong>${"Failed"}</strong>`,
              text: "Opps...! Something went wrong!",
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            console.error("Error uploading file:", error);
          });
      }
    });
  };

  render() {
    const { isPage404,msg, loadingList } = this.state;
    return !isPage404 ? (
      !loadingList?
      <div class="main-content">
        <ViewOnlyHeader url={this.state.companyInfo?.logo_url} name={this.state.companyInfo?.company_name} />
        <div class="">
          <div className="container-fluid">
            <br />
            <h4 className="font-semibold ">Candidate Details</h4>
            <div className="card">
              <div style={{ minHeight: "29rem" }} className="card-body">
                <div className="row gy-5">
                  <div className="col-md-3">
                    <div
                      style={{ display: "grid", gridTemplateColumns: "1fr" }}
                      className="nav gap-2"
                    >
                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2 ${
                          this.state.selectedInfoTab === "1" ? "active-tab" : ""
                        }`}
                        // id="v-pills-bill-info-tab"
                        type="button"
                        // role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "1" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Personal Details
                      </button>

                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2 
                          ${this.state.selectedInfoTab === "2"? "active-tab": ""}`}
                        // id="v-pills-bill-info-tab"
                        type="button"
                        // role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "2" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Family Details
                      </button>
                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2  
                          ${this.state.selectedInfoTab ==="3"? "active-tab": ""}`}
                        // id="v-pills-email-tab"
                        // data-bs-toggle='pill'
                        // data-bs-target='#v-pills-email'
                        type="button"
                        // role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "3" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Education Details
                      </button>
                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2 
                                                ${
                                                  this.state.selectedInfoTab ===
                                                  "4"
                                                    ? "active-tab"
                                                    : ""
                                                }`}
                        // id="v-pills-email-tab"
                        // data-bs-toggle='pill'
                        // data-bs-target='#v-pills-email'
                        type="button"
                        role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "4" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Work Experience
                      </button>
                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2 
                                                ${
                                                  this.state.selectedInfoTab ===
                                                  "5"
                                                    ? "active-tab"
                                                    : ""
                                                }`}
                        // id="v-pills-email-tab"
                        // data-bs-toggle='pill'
                        // data-bs-target='#v-pills-email'
                        type="button"
                        role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "5" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Bank Details
                      </button>
                      <button
                        className={`nav-tab d-flex justify-content-start align-items-center gap-2 
                                                ${
                                                  this.state.selectedInfoTab ===
                                                  "6"
                                                    ? "active-tab"
                                                    : ""
                                                }`}
                        // id="v-pills-email-tab"
                        // data-bs-toggle='pill'
                        // data-bs-target='#v-pills-email'
                        type="button"
                        role="tab"
                        onClick={() => this.setState({ selectedInfoTab: "6" })}
                      >
                        <i
                          className="ri-edit-box-line text-primary fs-20 mr-3"
                          style={{ fontSize: "24px" }}
                        />
                        Documents Details
                      </button>
                    </div>
                  </div>
                  <div
                    style={{ maxHeight: "80vh", overflowY: "scroll" }}
                    className="col-lg-9"
                  >
                    <div className="">
                      <div className="tab-content">
                        {/* Personal Details */}
                        {this.state.selectedInfoTab === "1" && (
                          <div
                            className=""
                            // id='v-pills-bill-info'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-bill-info-tab'
                          >
                            <PersonalDetails />
                          </div>
                        )}

                        {/* Family Details */}
                        {this.state.selectedInfoTab === "2" && (
                          <div
                            className=" "
                            // id='v-pills-bill-address'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-bill-address-tab'
                          >
                            <FamilyDetails />
                          </div>
                        )}

                        {/* Education Details */}
                        {this.state.selectedInfoTab === "3" && (
                          <div
                            className=" "
                            // id='v-pills-finish'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-finish-tab'
                          >
                            <EducationDetails />
                          </div>
                        )}

                        {/* Work Experience */}
                        {this.state.selectedInfoTab === "4" && (
                          <div
                            className=""
                            // id='v-pills-email'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-email-tab'
                          >
                            <WorkExperience />
                          </div>
                        )}

                        {/* Bank Details */}
                        {this.state.selectedInfoTab === "5" && (
                          <div
                            className=""
                            // id='v-pills-email'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-email-tab'
                          >
                            <BankDetails />
                          </div>
                        )}
                        {/* Documents Details */}
                        {this.state.selectedInfoTab === "6" && (
                          <div
                            className=""
                            // id='v-pills-email'
                            // role='tabpanel'
                            // aria-labelledby='v-pills-email-tab'
                          >
                            <DocumentDetails />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-4 px-4 d-flex justify-content-end align-items-center">
                {!this.state.loadingFinalSubmit ? (
                  this.state.selectedInfoTab === "6" ? (
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      className="btn btn-success btn-label waves-effect right waves-light"
                    >
                      <i className="bx bx-save label-icon align-middle fs-16 ms-2" />{" "}
                      Submit
                    </button>
                  ) : null
                ) : (
                  <button className="btn btn-success btn-load">
                    <span className="d-flex align-items-center">
                      <span
                        className="spinner-border flex-shrink-0"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </span>
                      <span className="flex-grow-1 ms-2">Loading...</span>
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>: (
        <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
        <div className="text-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
      )
    ) : isPage404 === "2" ? (
      <div>
        <div className="auth-page-wrapper bg-white py-1 d-flex justify-content-center align-items-center min-vh-100">
          {/* auth-page content */}
          <div className="auth-page-content overflow-hidden p-0">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-8">
                  <div className="text-center">
                    <img
                      src="assets/images/link_expired.png"
                      alt="link expired img"
                      className="img-fluid"
                    />
                    <div className="mt-3">
                      <h3 className="text-uppercase">
                        ❌ The link you followed has expired.
                      </h3>
                      {/* <p className="text-muted mb-4"></p> */}
                    </div>
                  </div>
                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end container */}
          </div>
          {/* end auth-page content */}
        </div>
      </div>
    ) :  isPage404 === "3" ?(
      <div>
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          {/* auth-page content */}
          <div className="auth-page-content overflow-hidden p-0">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-8">
                  <div className="text-center">
                    <img
                    style={{ width:"19%"}}
                      src="assets/images/check.png"
                      alt="check yes img"
                      className="img-fluid"
                    />
                    <div className="mt-3">
                      <h3 style={{color:"#4CD24C"}} className="  fw-bolder">
                        Thank You!
                      </h3>
                      <h3 className="">
                        {msg}
                      </h3>
                      <p className="text-muted mb-4">
                        We'll connect you when discussion is made.
                      </p>
                      {/* <NavLink to={'/'} className="btn btn-success"><i className="mdi mdi-home me-1" />Back to home</NavLink> */}
                    </div>
                  </div>
                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end container */}
          </div>
          {/* end auth-page content */}
        </div>
      </div>
    ) :
    (
      <div>
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          {/* auth-page content */}
          <div className="auth-page-content overflow-hidden p-0">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-8">
                  <div className="text-center">
                    <img
                      src="assets/images/error400-cover.png"
                      alt="error img"
                      className="img-fluid"
                    />
                    <div className="mt-3">
                      <h3 className="text-uppercase">
                        {msg || `Sorry, Page not Found 😭`}
                      </h3>
                      <p className="text-muted mb-4">
                        The page you are looking for not available!
                      </p>
                      {/* <NavLink to={'/'} className="btn btn-success"><i className="mdi mdi-home me-1" />Back to home</NavLink> */}
                    </div>
                  </div>
                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end container */}
          </div>
          {/* end auth-page content */}
        </div>
      </div>
    );
  }
}

export default CandidateDetails;
